// Supabase lets the project choose an email OTP length between 6 and 10 digits.
const OTP_MIN_LENGTH = 6
const OTP_MAX_LENGTH = 10

// Keeps only digits so a code pasted with spaces or line breaks still works.
export const normalizeOtpInput = (raw: string): string =>
    raw.replace(/\D/g, '').slice(0, OTP_MAX_LENGTH)

export const isOtpComplete = (code: string): boolean => code.length >= OTP_MIN_LENGTH

const RATE_LIMIT_CODES = ['over_email_send_rate_limit', 'over_request_rate_limit']

export const describeOtpError = (error: { code?: string; status?: number }): string => {
    if (error.code === 'otp_expired') {
        return 'Code invalide ou expiré. Utilisez le code du dernier e-mail reçu, ou demandez-en un nouveau.'
    }
    if (error.status === 429 || (error.code && RATE_LIMIT_CODES.includes(error.code))) {
        return 'Trop de tentatives. Patientez quelques minutes avant de réessayer.'
    }
    return 'Une erreur est survenue. Veuillez réessayer.'
}
